'use strict';

var debounce = require('lodash/debounce');
var components_visuallyHidden_VisuallyHidden = require('../components/visuallyHidden/VisuallyHidden.js');
require('react/jsx-runtime');
require('react');
require('../_chunks/combineClasses-5P8GTQkg.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var debounce__default = /*#__PURE__*/_interopDefault(debounce);

/* eslint-disable unicorn/filename-case */
const A11Y_ANNOUNCEMENT_ID = 'templafy-a11y-announcer';
const ANNOUNCEMENT_TIMEOUT = 500;
const debouncedClearAnnouncement = debounce__default.default(() => {
    getA11YAnnouncerElement().textContent = '';
}, ANNOUNCEMENT_TIMEOUT);
const getA11YAnnouncerElement = () => {
    const existingA11YAnnouncer = document.querySelector(`#${A11Y_ANNOUNCEMENT_ID}`);
    if (existingA11YAnnouncer) {
        return existingA11YAnnouncer;
    }
    const newAnnouncerElement = document.createElement('div');
    newAnnouncerElement.setAttribute('id', A11Y_ANNOUNCEMENT_ID);
    newAnnouncerElement.setAttribute('role', 'status');
    newAnnouncerElement.setAttribute('aria-live', 'polite');
    newAnnouncerElement.setAttribute('aria-relevant', 'additions text');
    newAnnouncerElement.classList.add(components_visuallyHidden_VisuallyHidden.visuallyHiddenStyles.visuallyHidden);
    document.body.append(newAnnouncerElement);
    return newAnnouncerElement;
};
const setA11YMessage = ({ message }) => {
    const announcement = getA11YAnnouncerElement();
    announcement.textContent = message;
    debouncedClearAnnouncement();
};
const debouncedSetA11yMessage = debounce__default.default(setA11YMessage, ANNOUNCEMENT_TIMEOUT);
/** Announces a message via an invisible aria-live element.
 *
 * Use this only if there are **absolutely no other ways** to communicate the message to the user.
 */
const announceA11YMessage = (args) => {
    getA11YAnnouncerElement(); // initialize the announcer element to ensure that edits to the live region are announced
    return debouncedSetA11yMessage(args);
};

exports.announceA11YMessage = announceA11YMessage;
//# sourceMappingURL=announceA11YMessage.js.map
